// extracted by mini-css-extract-plugin
export default {"DragnDrop":"Depositions_DragnDrop__FLGPy"};